import React from 'react';

const PayrollRow = ({
    payroll,
    companies,
    units,
    employees,
    canEditPayroll,
    canProcessPayroll,
    canDeletePayroll,
    handleEdit,
    handleProcess,
    handleDelete,
    getStatusBadge
}) => {
    const company = companies.find(c => c.company_id === payroll.company_id);
    const unit = units.find(u => u.unit_id === payroll.unit_id);
    const processor = employees.find(e => e.employee_id === payroll.processed_by);

    return (
        <tr key={payroll.payroll_id}>
            <td className="ps-4">
                <div className="d-flex align-items-center">
                    <div className="date-icon bg-primary text-white rounded d-flex flex-column align-items-center justify-content-center me-3"
                        style={{ width: '60px', height: '60px' }}
                    >
                        <div className="fs-6 fw-bold">
                            {payroll.month_year ? payroll.month_year.split('-')[1] : ''}
                        </div>
                        <div className="fs-8">
                            {payroll.month_year ? payroll.month_year.split('-')[0] : ''}
                        </div>
                    </div>
                    <div>
                        <div className="fw-semibold">
                            {payroll.month_year}
                        </div>
                        <small className="text-muted">
                            ID: {payroll.payroll_id}
                        </small>
                    </div>
                </div>
            </td>
            <td>
                <div>
                    <div className="fw-semibold">
                        {new Date(payroll.from_date).toLocaleDateString('en-US', {
                            day: 'numeric',
                            month: 'short',
                            year: 'numeric'
                        })}
                        {' to '}
                        {new Date(payroll.to_date).toLocaleDateString('en-US', {
                            day: 'numeric',
                            month: 'short',
                            year: 'numeric'
                        })}
                    </div>
                    <small className="text-muted">
                        {Math.ceil((new Date(payroll.to_date) - new Date(payroll.from_date)) / (1000 * 60 * 60 * 24)) + 1} days
                    </small>
                </div>
            </td>
            <td>
                <div className="fw-semibold">{company?.company_name || 'N/A'}</div>
                <small className="text-muted">{unit?.unit_name || 'N/A'}</small>
            </td>
            <td>
                <span className={`badge ${getStatusBadge(payroll.status)}`}>
                    {payroll.status}
                </span>
            </td>
            <td>
                {payroll.processed_on ? (
                    <div>
                        <div className="small">
                            {new Date(payroll.processed_on).toLocaleDateString()}
                        </div>
                        <small className="text-muted">
                            By: {processor?.employee_name || 'Unknown'}
                        </small>
                    </div>
                ) : (
                    <span className="text-muted">Not processed</span>
                )}
            </td>
            <td className="text-end pe-4">
                <div className="btn-group" role="group">
                    {canEditPayroll && (
                        <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={() => handleEdit(payroll)}
                            title="Edit Payroll Period"
                        >
                            <i className="bi bi-pencil"></i>
                        </button>
                    )}
                    {canProcessPayroll && payroll.status === 'Open' && (
                        <button
                            className="btn btn-outline-success btn-sm"
                            onClick={() => handleProcess(payroll)}
                            title="Process Payroll"
                        >
                            <i className="bi bi-play-circle"></i>
                        </button>
                    )}
                    {canDeletePayroll && payroll.status === 'Open' && (
                        <button
                            className="btn btn-outline-danger btn-sm"
                            onClick={() => handleDelete(payroll)}
                            title="Delete Payroll Period"
                        >
                            <i className="bi bi-trash"></i>
                        </button>
                    )}
                </div>
            </td>
        </tr>
    );
};

export default PayrollRow;